import React, { useState } from 'react';
import '../css/ContactPage.css';

const ContactForm = () => {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
        alert('Thank you for your message! We will get back to you soon.');
        setFormData({ name: '', email: '', message: '' });
    };

    return (
        <div className="contact-wrapper">
            <div className="contact-info">
                <span className="contact-info-section-label">Contact Us</span>
                <h1>Let's Start a Conversation</h1>
                <p>
                    Have a project in mind or want to learn more about what we do? Reach out and
                    we'll get back to you within one business day.
                </p>
                <div className="contact-detail">
                    <div className="contact-detail-icon">📧</div>
                    <span>nm@callidellc.com</span>
                </div>
                <div className="contact-detail">
                    <div className="contact-detail-icon">📍</div>
                    <span>Fond du Lac, WI, USA</span>
                </div>
            </div>

            <div className="contact-form-card">
                <h2>Send a Message</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="Your name"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="your@email.com"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">Message</label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="5"
                            required
                            placeholder="Tell us about your project..."
                        />
                    </div>
                    <button type="submit" className="btn-submit">Send Message &rarr;</button>
                </form>
            </div>
        </div>
    );
};

export default ContactForm;
